<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <div class="p-grid">
          <div class="p-col-12 p-d-flex p-justify-between">
            <h4>ข้อมูลพนักงาน</h4>
            <back-button class="p-ml-2" />
          </div>
          <div class="p-col-12">
            <div class="p-grid">
              <div class="p-col-12 p-lg-4 p-md-6 p-fluid">
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="pi pi-search"></i>
                  </span>
                  <InputText
                    v-model="searchString"
                    placeholder="ระบุคำค้น (รหัส, ชื่อ, นามสกุล)..."
                  ></InputText>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-12">
            <DataTable
              :paginator="true"
              :rows="10"
              :rowsPerPageOptions="[10, 20, 50]"
              :value="employees"
              class="p-datatable-sm"
              ref="employeeTable"
              dataKey="courseTypeId"
              stateStorage="session"
              stateKey="employee-list"
            >
              <template #empty>ไม่พบข้อมูล</template>
              <Column
                field="id"
                header="รหัส"
                headerStyle="width: 6rem"
                bodyStyle="width: 6rem;"
                :sortable="true"
              >
              </Column>
              <Column field="name" header="ชื่อ" :sortable="true">
                <template #body="props">
                  {{ props.data.prename }}{{ props.data.name }}
                  {{ props.data.surname }}
                </template>
              </Column>
              <Column
                field="position"
                header="ตำแหน่ง"
                :sortable="true"
              ></Column>
              <Column header="Division">
                <template #body="props">
                  {{ props.data.divisionCode }} -
                  {{ props.data.divisionDescription }}
                </template>
              </Column>
              <Column header="Department">
                <template #body="props">
                  {{ props.data.departmentCode }} -
                  {{ props.data.departmentDescription }}
                </template>
              </Column>
              <Column
                field="position"
                header="ตำแหน่ง"
                :sortable="true"
              ></Column>
              <Column
                field="level"
                header="Level"
                headerStyle="width: 6rem"
                bodyStyle="width: 6rem; text-align: center"
                :sortable="true"
              ></Column>
              <Column
                field="sex"
                header="เพศ"
                headerStyle="width: 6rem"
                bodyStyle="width: 6rem; text-align: center"
                :sortable="true"
              >
                <template #body="props">
                  {{
                    props.data.sex
                      ? props.data.sex === "M"
                        ? "ชาย"
                        : "หญิง"
                      : "ไม่ระบุ"
                  }}
                </template>
              </Column>
              <Column
                header="Email"
                headerStyle="width:4rem"
                bodyStyle="width:4rem"
              >
                <template #body="props">
                  <i
                    class="pi pi-id-card"
                    v-if="props.data.email"
                    v-tooltip="`${props.data.email}`"
                  ></i>
                </template>
              </Column>
              <Column headerStyle="width:4rem" bodyStyle="width:4rem">
                <template #body="props">
                  <Button
                    @click="onShowEmployee(props.data.id)"
                    class="p-button-rounded"
                    icon="pi pi-eye"
                  ></Button>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, onMounted } from "vue";
import { debouncedWatch, useSessionStorage } from "@vueuse/core";
import { usePlugin } from "@/plugins";
import { GetEmployeeResponse, Employee } from "@/types";
import BackButton from "@/components/BackButton.vue";
export default {
  name: "CourseType",
  components: { BackButton },
  setup() {
    const { error, axios, setLoading, onRouterPush } = usePlugin();

    const employeeTable = ref(null);
    const employees = ref<Employee[]>([]);
    const searchString = useSessionStorage("employee-searchString", "");

    // const filteredCourseType = computed(() => {
    //   if (!searchString.value) return courseTypes.value;
    //   const fuse = new Fuse(courseTypes.value, {
    //     keys: ["courseTypeId", "description"],
    //   });
    //   const searchResult = fuse.search(searchString.value);
    //   return searchResult.map((x) => x.item);
    // });

    const loadEmployees = async () => {
      setLoading(true);
      try {
        const result = await axios.post<GetEmployeeResponse>(
          "api/v1/services/employee/get",
          { searchString: searchString.value }
        );
        employees.value = result.data.employees ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onShowEmployee = (id: string) => {
      onRouterPush({ name: "employee", params: { id: id } });
    };

    onMounted(async () => {
      await loadEmployees();
    });

    debouncedWatch(searchString, loadEmployees, { debounce: 500 });
    return {
      employeeTable,
      employees,
      searchString,
      onShowEmployee,
    };
  },
};
</script>
